/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { post } from "@insite/client-framework/Services/ApiService";
import { AddWishListLinesApiParameter } from "@insite/client-framework/Services/WishListService";

export interface XngAddWishListLinesApiParameter extends AddWishListLinesApiParameter {
    properties?: {
        isUploadItemsButton?: boolean;
        notFoundProducts?: string;
    };
}

export function xngAddWishListLines(parameter: XngAddWishListLinesApiParameter) {
    const { properties } = parameter;
    const wishListLinesUri = parameter.wishList.wishListLinesUri.substr(
        parameter.wishList.wishListLinesUri.indexOf("/api/v1"),
    );
    return post(`${wishListLinesUri}/batch`, { wishListLines: parameter.lines, properties });
}
